module.exports = __webpack_public_path__ + "static/media/socceroos.00137872.svg";